import { render, staticRenderFns } from "./preVenda.vue?vue&type=template&id=c53b7c86"
import script from "./preVenda.ts?vue&type=script&lang=js&external"
export * from "./preVenda.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c53b7c86')) {
      api.createRecord('c53b7c86', component.options)
    } else {
      api.reload('c53b7c86', component.options)
    }
    module.hot.accept("./preVenda.vue?vue&type=template&id=c53b7c86", function () {
      api.rerender('c53b7c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/preVenda/preVenda.vue"
export default component.exports